

import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas/rootSaga";
import rootReducer from "./reducers/rootReducer";


function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    console.error("Error saving to local storage", e);
  }
}

function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem("state");
    if (!serializedState) return undefined;

    const parsed = JSON.parse(serializedState);
    // Guards against leftover localStorage["state"] from an unrelated app
    // that previously ran on the same origin/port — its shape won't match
    // this store's reducers at all.
    if (!parsed || typeof parsed !== "object" || !("auth" in parsed)) {
      localStorage.removeItem("state");
      return undefined;
    }

    return parsed;
  } catch (e) {
    console.error("Error loading from local storage", e);
    return undefined;
  }
}

const persistedState = loadFromLocalStorage();
const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["payload.callback", "data.callback"],
      },
    }).concat(middleware),
});

sagaMiddleware.run(rootSaga);

store.subscribe(() => {
  const state = store.getState();
  if (!state.auth?.accessToken) {
    localStorage.removeItem("state");
    return;
  }
  saveToLocalStorage(state);
});

export default store;
